import * as React from "react"
import {
  Checkbox as ChakraCheckbox,
} from "@chakra-ui/react"

export function CheckboxChakra({
  label,
  name,
  value = "on",
  checked,
  defaultChecked,
  onCheckedChange,
  variant = "solid",
  size = "md",
  colorPalette = "blue",
  form,
  id,
  required = false,
  disabled = false,
  ...rest
}) {
  return (
    <ChakraCheckbox.Root
      name={name}
      value={value}
      checked={checked}
      defaultChecked={defaultChecked}
      onCheckedChange={onCheckedChange}
      variant={variant}
      size={size}
      colorPalette={colorPalette}
      form={form}
      id={id}
      required={required}
      disabled={disabled}
      {...rest}
    >
      <ChakraCheckbox.HiddenInput />
      <ChakraCheckbox.Control />
      <ChakraCheckbox.Label>{label}</ChakraCheckbox.Label>
    </ChakraCheckbox.Root>
  )
}
